import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ShopService } from '@app/services/shops/shop.service';
import { specialFeaturesActions } from '../../store/actions';
import * as dashboardSelectors from '../../store/selectors';
import { IState } from '../../store/states';
import { ISpecialLabel, ISpecialLabelOptions } from '../../store/states/special-features';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-dashboard-special-features-special-label-section',
  templateUrl: './dashboard-special-features-special-label-section.component.html',
  styleUrls: ['./dashboard-special-features-special-label-section.component.scss', '../../styles/_dashboard.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class DashboardSpecialFeaturesSpecialLabelSectionComponent implements OnInit, OnDestroy {
  private data: ISpecialLabel;
  private ngUnsubscribe$ = new Subject<any>();
  private _currentShopId: number;

  constructor(
    private dashboardStore: Store<IState>,
    private _shopService: ShopService,
  ) {}

  ngOnInit(): void {
    this.initData();
  }

  private initData() {
    this.dashboardStore
      .select(dashboardSelectors.specialFeaturesSelectors.selectSpecialLabel)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((data) => (this.data = data));

    this._shopService.shop$
      .pipe(untilDestroyed(this))
      .subscribe((currentShop) => (this._currentShopId = currentShop?.id));
  }

  private ngUnsubscribe() {
    this.ngUnsubscribe$.next(true);
    this.ngUnsubscribe$.complete();
  }

  get isActive(): boolean {
    return this.data.isSpecialLabelActive;
  }

  get options(): ISpecialLabelOptions {
    return this.data.options;
  }

  onIsSpecialLabelActiveChange(): void {
    this.dashboardStore.dispatch(
      specialFeaturesActions.setIsSpecialLabelActive({
        isSpecialLabelActive: !this.data.isSpecialLabelActive,
        shopId: this._currentShopId,
      }),
    );
  }

  onHasReturnNoteChange(): void {
    this.dashboardStore.dispatch(
      specialFeaturesActions.setSpecialLabelOptions({
        hasReturnNode: !this.data.options.hasReturnNode,
        shopId: this._currentShopId,
      }),
    );
  }

  onHasNoItemsChange(): void {
    this.dashboardStore.dispatch(
      specialFeaturesActions.setSpecialLabelOptions({
        hasNoItems: !this.data.options.hasNoItems,
        shopId: this._currentShopId,
      }),
    );
  }

  onHasGovinaChange(): void {
    this.dashboardStore.dispatch(
      specialFeaturesActions.setSpecialLabelOptions({
        hasGovina: !this.data.options.hasGovina,
        shopId: this._currentShopId,
      }),
    );
  }

  onHasNoteChange(): void {
    this.dashboardStore.dispatch(
      specialFeaturesActions.setSpecialLabelOptions({
        hasNote: !this.data.options.hasNote,
        shopId: this._currentShopId,
      }),
    );
  }

  onHasGreetingCardChange(): void {
    this.dashboardStore.dispatch(
      specialFeaturesActions.setSpecialLabelOptions({
        hasGreetingCard: !this.data.options.hasGreetingCard,
        shopId: this._currentShopId,
      }),
    );
  }

  ngOnDestroy() {
    this.ngUnsubscribe();
  }
}
